import {Dates} from "./Dates";
import {Files} from "./Files";
import {Api} from "../api";

export var ExportUtils = {

	sendExportRequest (path, context) {
		Api.post(context,
			path,
			{searchParams: {countryId: null}, fields: [{id: "PROJECT_START_DATE", name: "Data rozpoczęcia projektu (1)", module: 1, type: "CONSTANT_MODULE"}]},
			success => {
				let filename = "egranty_export_" + Dates.methods.getFilenameTimestamp() + ".xlsx";
				context.$messagesBus.$emit("success", "Eksport danych z tabeli wykonano do pliku " + filename,
					success);
				Files.methods.downloadBlobResponse(success, filename);
			},
			error => context.$messagesBus.$emit("error", "Eksport nieudany", error),
			{
				responseType: "blob"
			});
	},

	sendExportCsvRequest (path, context) {
		Api.post(context,
			path,
			{searchParams: {countryId: null}, fields: []},
			success => {
				let filename = "egranty_logi_systemowe_export_" + Dates.methods.getFilenameTimestamp() + ".csv";
				context.$messagesBus.$emit("success", "Eksport danych z tabeli wykonano do pliku " + filename,
					success);
				Files.methods.downloadBlobResponse(success, filename);
			},
			error => context.$messagesBus.$emit("error", "Eksport nieudany", error),
			{
				responseType: "blob"
			});
	}
};